export function calculatePercentComplete(completed, toComplete) {
    if (completed === 0 && toComplete === 0) {
        // zero steps procedure
        return 0;
    }
    else if (toComplete === 0) {
        return 100;
    }
    // when no ending node is found, return null as percentage
    // no percentage at all is better than an always-zero one
    if (completed === Infinity || toComplete === Infinity) {
        return null;
    }
    var total = completed + toComplete;
    return (completed / total) * 100;
}
export function subtractFromSet(container, toRemove) {
    var updated = new Set(container);
    toRemove.forEach(function (item) { return updated.delete(item); });
    return updated;
}
